import styled from "styled-components";

export const StyledSearchSelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  & > div {
    &:first-child {
      width: 278px;
    }
    &:last-child {
      width: 220px;
    }
  }
`;

export const StyledFinalFeedbackPendingContainer = styled.div<{
  $readySendSheet?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  margin: 0px 20px;

  & > div:nth-child(2) > div {
    height: ${({ $readySendSheet: readySendSheet }) =>
      readySendSheet ? "calc(100dvh - 380px)" : "calc(100dvh - 315px)"};
  }

  & > .empty-state {
    display: flex;
    justify-content: center;
    height: 100%;
  }
`;
